import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import AppHeader from "@/components/AppHeader";
import LandingPage from "@/pages/LandingPage";
import QuizIntroPage from "@/pages/QuizIntroPage";
import QuizPlayPage from "@/pages/QuizPlayPage";
import QuizResultPage from "@/pages/QuizResultPage";
import ChallengeLandingPage from "@/pages/ChallengeLandingPage";
import ChallengeResultPage from "@/pages/ChallengeResultPage";
import ApplyTypePage from "@/pages/ApplyTypePage";
import ApplyFormPage from "@/pages/ApplyFormPage";
import ApplyThanksPage from "@/pages/ApplyThanksPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminQuestionsPage from "@/pages/admin/AdminQuestionsPage";
import AdminConfigPage from "@/pages/admin/AdminConfigPage";
import AdminLeadsPage from "@/pages/admin/AdminLeadsPage";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col mesh-bg">
      <AppHeader />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
    </div>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/questions" element={<AdminQuestionsPage />} />
        <Route path="/admin/config" element={<AdminConfigPage />} />
        <Route path="/admin/leads" element={<AdminLeadsPage />} />
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/quiz/intro" element={<QuizIntroPage />} />
        <Route path="/quiz/play" element={<QuizPlayPage />} />
        <Route path="/quiz/result" element={<QuizResultPage />} />
        <Route path="/challenge/:challengeId" element={<ChallengeLandingPage />} />
        <Route path="/challenge/result" element={<ChallengeResultPage />} />
        <Route path="/apply/type" element={<ApplyTypePage />} />
        <Route path="/apply/form" element={<ApplyFormPage />} />
        <Route path="/apply/thanks" element={<ApplyThanksPage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-right" theme="dark" />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
